import { Box } from '@mui/material';
import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

const DataGridBox = ({ children }: Props): JSX.Element => {
  return <Box height="60vh">{children}</Box>;
};

export default DataGridBox;
